import React from "react";
import { withStyles } from "@material-ui/core/styles";
import cx from "classnames";

const styles = () => ({
  root: {
    display: "flex",
    alignItems: "center"
  },
  icon: {
    // position: "relative",
    top: "5px",
    left: "5px",
    marginRight: "6px"
  },
  alignTop: {
    display: "flex",
    alignItems: "baseline"
  }
});

const IconText = ({
  classes,
  src,
  dataSrc,
  children,
  height,
  width,
  align = "",
  className,
  marginRight = "",
  imgClass = "",
  id = "",
  alt = "",
  showIcon = true
}) => (
  <div
    id={id}
    className={cx(align ? classes.alignTop : classes.root, className)}
  >
    {showIcon ? (
      <img
        className={cx(imgClass ? imgClass : null, classes.icon)}
        data-src={dataSrc}
        src={src}
        id={id}
        height={height}
        width={width}
        style={marginRight ? { marginRight } : null}
        alt={alt}
      />
    ) : null}
    {children}
  </div>
);

export default withStyles(styles)(IconText);
